import dynamic from 'next/dynamic'

export const ImpersonationIndicatorDynamic = dynamic(
  () => import('./ImpersonationIndicator').then((m) => m.ImpersonationIndicator),
  { ssr: false },
)
